// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc6b23b5","239":"532fc1e0","453":"8e0b564c","667":"b347db4c"}[chunkId] + ".chunk.js";
};